exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nd-drag[data-v-1f047d2f] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}", ""]);

// exports
